import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import pt_BR from '@/locales/pt_BR.json';
import {
    isLocaleLockedToPortuguese,
    LOCKED_LOCALE,
    type AppLocale,
} from '@/i18n/resolveAppLocale';

export type MessageSchema = typeof en;

export function createI18nPlugin(initialLocale: AppLocale = 'en') {
    const locale = isLocaleLockedToPortuguese() ? LOCKED_LOCALE : initialLocale;

    return createI18n<[MessageSchema], AppLocale>({
        legacy: false,
        globalInjection: true,
        locale,
        fallbackLocale: LOCKED_LOCALE,
        messages: {
            en,
            pt_BR,
        },
    });
}

export {
    applyLockedLocaleCookie,
    isLocaleLockedToPortuguese,
    LOCKED_LOCALE,
    resolveAppLocale,
    type AppLocale,
} from '@/i18n/resolveAppLocale';
